import Swiper from 'swiper'
import { Autoplay } from 'swiper/modules'

document.addEventListener('DOMContentLoaded', () => {
    const slider = document.querySelector('.about-akfa-mobile__swiper')
    if (!slider) return

    new Swiper(slider, {
        modules: [Autoplay],
        slidesPerView: 'auto',
        spaceBetween: 12,
        loop: true,
        speed: 6000,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        breakpoints: {
            768: {
                spaceBetween: 24,
            },
        },
    })
})
